/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OutDealProductDTO
 */
export interface OutDealProductDTO {
  /**
   *
   * @type {string}
   * @memberof OutDealProductDTO
   */
  slug: string;
  /**
   *
   * @type {string}
   * @memberof OutDealProductDTO
   */
  title: string;
  /**
   *
   * @type {number}
   * @memberof OutDealProductDTO
   */
  dealCount: number;
}

/**
 * Check if a given object implements the OutDealProductDTO interface.
 */
export function instanceOfOutDealProductDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "slug" in value;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "dealCount" in value;

  return isInstance;
}

export function OutDealProductDTOFromJSON(json: any): OutDealProductDTO {
  return OutDealProductDTOFromJSONTyped(json, false);
}

export function OutDealProductDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutDealProductDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    slug: json["slug"],
    title: json["title"],
    dealCount: json["dealCount"]
  };
}

export function OutDealProductDTOToJSON(value?: OutDealProductDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    slug: value.slug,
    title: value.title,
    dealCount: value.dealCount
  };
}
